import React from 'react';
import LazyLoad from 'react-lazyload';
import PhoneMockUp from '../../assets/mockup.png';
import SignUpOnPage from '../SignUpOnPage';


import {
  PhoneMockUpImg,
  SignUpFormWrapper,
  MockUpFormWrapper,
  MockUpTitleDesktop,
} from './MockUpSignUpForm.styles';


export const MockUpSignUpForm = () => {
  return (
    <React.Fragment>
      <MockUpFormWrapper>
        <LazyLoad height={400}>
          <PhoneMockUpImg src={PhoneMockUp} alt="Mock up of Starlies Newsletter" width="400" />
        </LazyLoad>
        <SignUpFormWrapper>
          <MockUpTitleDesktop>
            Starguide is your guide to unlocking the stars for life, love,
            and everything in between.
          </MockUpTitleDesktop>
          <SignUpOnPage />
        </SignUpFormWrapper>
      </MockUpFormWrapper>
    </React.Fragment>
  );
};


export default MockUpSignUpForm;

